import { AppConfigService } from './app-config/app-config.service'

export class UrlCollection {
  static Admin = class {
    static INFO(): string {
      return UrlCollection.ADMIN_API_BASE_PATH() + '/info'
    }
    static UPLOAD_LICENSE(): string {
      return UrlCollection.ADMIN_API_BASE_PATH() + '/uploadLicense'
    }
  }

  static UserManagement = class {
    static Actions = class {
      static ADD(): string {
        return UrlCollection.USER_ACTIONS_BASE_PATH() + '/add'
      }
    }

    static Right = class {
      static ALL_ACTIONS = (roleId: number) => `${UrlCollection.UserManagement.ROLE()}/${roleId}/allActions`
      static ADD_ACTION = (roleId: number) => `${UrlCollection.UserManagement.ROLE()}/${roleId}/addAction`
      static REMOVE_ACTION = (roleId: number) => `${UrlCollection.UserManagement.ROLE()}/${roleId}/removeAction`
      static GET_MASTER_ROLE(): string {
        return UrlCollection.USER_API_BASE_PATH() + '/masterrole'
      }
    }

    static CREATE(): string {
      return UrlCollection.USER_API_BASE_PATH() + '/create'
    }
    static ALL(): string {
      return UrlCollection.USER_API_BASE_PATH() + '/all'
    }
    static GET(): string {
      return UrlCollection.USER_API_BASE_PATH() + '/get'
    }
    static UPDATE(): string {
      return UrlCollection.USER_API_BASE_PATH() + '/update'
    }
    static DELETE(): string {
      return UrlCollection.USER_API_BASE_PATH() + '/delete'
    }
    static LOGIN(): string {
      return UrlCollection.USER_API_BASE_PATH() + '/login'
    }
    static LOGOUT(): string {
      return UrlCollection.USER_API_BASE_PATH() + '/logout'
    }
    static CHANGE_PASSWD(): string {
      return UrlCollection.USER_API_BASE_PATH() + '/changepwd'
    }

    static ROLE(): string {
      return UrlCollection.USER_API_BASE_PATH() + '/role'
    }
    static VALIDATE_TOKEN(token: string): string {
      return UrlCollection.USER_API_BASE_PATH() + '/validateToken/' + token
    }
    static PROLONG_TOKEN(): string {
      return UrlCollection.USER_API_BASE_PATH() + '/prolongToken'
    }

    static buildGetUrl(userName: string) {
      return UrlCollection.UserManagement.GET() + '/' + userName
    }
  }

  static Entities = class {
    static CREATE(): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/create'
    }
    static UPDATE(): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/update'
    }
    static DELETE(): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/delete'
    }
    static CONFIGS(): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/configurations'
    }
    static GET = (type: string, id: number) => UrlCollection.ENTITY_API_BASE_PATH() + '/get/' + type + '/' + id
    static GET_BY_HRID = (type: string, hrid: string) =>
      UrlCollection.ENTITY_API_BASE_PATH() + '/getByHrid/' + type + '/' + hrid
    static FILTER(): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/filter'
    }
    static COUNT(): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/count'
    }
    static EXPORT(type: string): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/export/' + type
    }
    static CONFIG_FILE = (configName: string) =>
      UrlCollection.ENTITY_API_BASE_PATH() + '/configuration/file/' + configName
    static GET_TEMPLATE_FIELDS(templateId: number, dtoType: string): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + `/template/${dtoType}/${templateId}`
    }
    static SELECT_ALL(): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/selectAll'
    }
    static UNSELECT_ALL(): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/unselectAll'
    }
    static GET_SELECTED_COUNT(type: string): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/selectedCount/' + type
    }
    static SELECT(): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/select'
    }
    static UNSELECT(): string {
      return UrlCollection.ENTITY_API_BASE_PATH() + '/unselect'
    }
  }

  static Groups = class {
    static ADDMEMBER(): string {
      return UrlCollection.GROUPS_API_BASE_PATH() + '/addmember'
    }
    static ADDMEMBERS(): string {
      return UrlCollection.GROUPS_API_BASE_PATH() + '/addmembers'
    }
    static REMOVEMEMBER(): string {
      return UrlCollection.GROUPS_API_BASE_PATH() + '/removemember'
    }
    static REMOVEMEMBERS(): string {
      return UrlCollection.GROUPS_API_BASE_PATH() + '/removemembers'
    }
    static CONFIGS(): string {
      return UrlCollection.GROUPS_API_BASE_PATH() + '/configurations'
    }
    static MEMBERS(): string {
      return UrlCollection.GROUPS_API_BASE_PATH() + '/members'
    }
    static MEMBERIDS(): string {
      return UrlCollection.GROUPS_API_BASE_PATH() + '/memberIds'
    }
    static REORDERMEMBER(): string {
      return UrlCollection.GROUPS_API_BASE_PATH() + '/reordermember'
    }
    static REORDERMEMBERS(): string {
      return UrlCollection.GROUPS_API_BASE_PATH() + '/reordermembers'
    }
  }

  static Catalogues = class {
    static CREATE(): string {
      return UrlCollection.CATALOGUE_API_BASE_PATH() + '/create'
    }
    static GET(): string {
      return UrlCollection.CATALOGUE_API_BASE_PATH() + '/get'
    }
    static ALL(): string {
      return UrlCollection.CATALOGUE_API_BASE_PATH() + '/all'
    }
    static DELETE(): string {
      return UrlCollection.CATALOGUE_API_BASE_PATH() + '/delete'
    }
    static ADDENTRY(): string {
      return UrlCollection.CATALOGUE_API_BASE_PATH() + '/addEntry'
    }
    static REMOVEENTRY(): string {
      return UrlCollection.CATALOGUE_API_BASE_PATH() + '/removeEntry'
    }
    static GETBYEXPRESSION(): string {
      return UrlCollection.CATALOGUE_API_BASE_PATH() + '/getByExpression'
    }
  }

  static Attachments = class {
    static attach = (): string => UrlCollection.basePathAttachment() + '/attach'
    static all = (): string => UrlCollection.basePathAttachment() + '/all'
  }

  static Files = class {
    static generateDownloadUrl = (id: number) => UrlCollection.FILE_API_BASE_PATH() + '/download/' + id
    static generateDownloadTempFileUrl = (id: string) => UrlCollection.FILE_API_BASE_PATH() + '/downloadTempFile/' + id
    static generateFileAttachmentUploadUrl = (ownerType: string, ownerId: number) =>
      UrlCollection.FILE_API_BASE_PATH() + '/upload/' + ownerType + '/' + ownerId
    static generateUploadUrl = () => UrlCollection.FILE_API_BASE_PATH() + '/upload/'
    static UPDATE(): string {
      return UrlCollection.FILE_API_BASE_PATH() + '/update/'
    }
    static TEST_NEXTCLOUD_CONNECTION = (): string => UrlCollection.FILE_API_BASE_PATH() + '/testNextCloudConnection'
  }

  static EntityAttachments = class {
    static ENTRIES = (attachmentType: string, entityType: string, id: number) =>
      UrlCollection.ENTITY_ATTACHMENT_API_BASE_PATH(attachmentType) + '/entries/' + entityType + '/' + id
    static REMOVE = (attachmentType: string) =>
      UrlCollection.ENTITY_ATTACHMENT_API_BASE_PATH(attachmentType) + '/remove'
    static UPDATE = (attachmentType: string) =>
      UrlCollection.ENTITY_ATTACHMENT_API_BASE_PATH(attachmentType) + '/update'
    static ADD = (attachmentType: string) => UrlCollection.ENTITY_ATTACHMENT_API_BASE_PATH(attachmentType) + '/add'
  }

  static EntityAttributes = class {
    static ENTRIES = (entityType: string, id: number) =>
      UrlCollection.ENTITY_ATTRIBUTE_API_BASE_PATH() + '/entries/' + entityType + '/' + id
    static REMOVE(): string {
      return UrlCollection.ENTITY_ATTRIBUTE_API_BASE_PATH() + '/remove'
    }
    static UPDATE(): string {
      return UrlCollection.ENTITY_ATTRIBUTE_API_BASE_PATH() + '/update'
    }
    static ADD(): string {
      return UrlCollection.ENTITY_ATTRIBUTE_API_BASE_PATH() + '/add'
    }
  }

  static Actions = class {
    static GETACTION(): string {
      return UrlCollection.SCRIPT_API_BASE_PATH() + '/getAction'
    }
    static EXECUTE(): string {
      return UrlCollection.SCRIPT_API_BASE_PATH() + '/executeAction'
    }
    static EXECUTESNIPPET(): string {
      return UrlCollection.SCRIPT_API_BASE_PATH() + '/execute'
    }
    static EVAL(): string {
      return UrlCollection.SCRIPT_API_BASE_PATH() + '/eval/'
    }
  }

  static QuickNotes = class {
    static GET(dtoType, id): string {
      return UrlCollection.QUICK_NOTE_API_BASE_PATH() + '/' + dtoType + '/' + id
    }
    static UPDATE(): string {
      return UrlCollection.QUICK_NOTE_API_BASE_PATH() + '/update'
    }
    static REMOVE(): string {
      return UrlCollection.QUICK_NOTE_API_BASE_PATH() + '/remove'
    }
  }

  static Config = class {
    static CUSTOMERLOGO(): string {
      return UrlCollection.CONFIG_API_BASE_PATH() + '/customerlogo'
    }
    static WELCOME_TEXT(): string {
      return UrlCollection.CONFIG_API_BASE_PATH() + '/welcomeTxt'
    }
  }

  static Settings = class {
    static GET_SYSTEM_SETTINGS = (): string => UrlCollection.SETTINGS_API_BASE_PATH() + '/all'
    static GET_USER_SETTINGS = (): string => UrlCollection.SETTINGS_API_BASE_PATH() + '/userOverridable/all'
    static GET_SETTING = (settingName: string): string => UrlCollection.SETTINGS_API_BASE_PATH() + '/' + settingName
    static SET_SYSTEM_SETTING = (): string => UrlCollection.SETTINGS_API_BASE_PATH() + '/set'
    static SET_USER_SETTING = (): string => UrlCollection.SETTINGS_API_BASE_PATH() + '/userOverridable/set'
  }

  static Menu = class {
    static ITEMS(): string {
      return UrlCollection.MENU_API_BASE_PATH() + '/items'
    }
  }

  static Statemachine = class {
    static CURRENT_STATE(entityType: string, id: number): string {
      return UrlCollection.STATEMACHINE_API_BASE_PATH() + '/instance/' + entityType + '/' + id
    }
    static NEXT(): string {
      return UrlCollection.STATEMACHINE_API_BASE_PATH() + '/instance/next'
    }
    static GET_STATES(): string {
      return UrlCollection.STATEMACHINE_API_BASE_PATH() + '/getStates'
    }
  }

  static Wizard = class {
    static INIT(): string {
      return UrlCollection.WIZARD_API_BASE_PATH() + `/init`
    }
    static GET(executorId: string): string {
      return UrlCollection.WIZARD_API_BASE_PATH() + `/get/` + executorId
    }
    static UPDATE_FIELD() {
      return UrlCollection.WIZARD_API_BASE_PATH() + '/updateField'
    }
    static CLICK_BUTTON() {
      return UrlCollection.WIZARD_API_BASE_PATH() + '/clickButton'
    }
    static CLOSE() {
      return UrlCollection.WIZARD_API_BASE_PATH() + '/close'
    }
    static SELECT_ENTITY() {
      return UrlCollection.WIZARD_API_BASE_PATH() + '/selectEntity'
    }
  }

  static ADMIN_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/admin'
  }
  static USER_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/user'
  }
  static USER_ACTIONS_BASE_PATH(): string {
    return UrlCollection.USER_API_BASE_PATH() + '/actions'
  }
  static USER_RIGHTS_BASE_PATH(): string {
    return UrlCollection.USER_API_BASE_PATH() + '/right'
  }
  static ENTITY_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/entities'
  }
  static CATALOGUE_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/catalogue'
  }
  static FILE_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/file'
  }
  static GROUPS_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/groups'
  }
  static ENTITY_ATTACHMENT_API_BASE_PATH(attachmentType: string): string {
    return AppConfigService.getBaseUrl() + '/' + attachmentType
  }
  static ENTITY_ATTRIBUTE_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/attribute'
  }
  static SCRIPT_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/script'
  }
  static QUICK_NOTE_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/quicknote'
  }
  static CONFIG_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/config'
  }
  static MENU_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/config/menu'
  }
  static SETTINGS_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/settings'
  }
  static STATEMACHINE_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/statemachine'
  }
  static WIZARD_API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl() + '/wizard'
  }
  static API_BASE_PATH(): string {
    return AppConfigService.getBaseUrl()
  }

  static EVAL_SOFT_FILTER(): string {
    return UrlCollection.ENTITY_API_BASE_PATH() + '/evaluateSoftFilter'
  }

  static basePathAttachment(): string {
    return AppConfigService.getBaseUrl() + '/attachment'
  }

  static Userstore = class {
    static GET(key: string): string {
      return UrlCollection.API_BASE_PATH() + `/userstore/get/${key}`
    }
    static SAVE(key: string): string {
      return UrlCollection.API_BASE_PATH() + `/userstore/${key}`
    }
    static REMOVE(key: string): string {
      return UrlCollection.API_BASE_PATH() + `/userstore/remove/${key}`
    }
  }
}
